<template>
  <q-tab-pane name="tax-advisor">
    <div class="row gutter-x-md justify-start">
      <div class="col-md-3 col-12">
        <h6 class="q-mt-md q-mb-sm q-title">{{ $t('tax_advisor') }}</h6>
        <p class="text-faded">{{ $t('tax_advisor_hint') }}</p>
      </div>

      <div class="col-md-9 col-12">
        <!-- Customer Number Format -->
        <q-field
          :label="$t('tax_advisor_email')"
          :labelWidth="3"
        >
          <q-input
            v-model="email"
            v-validate.disable="'required|min:1|max:255'"
            name="email"
            :placeholder="$t('email')"
          />

          <div class="row items-center q-mt-xs">
            <span class="text-grey-5">{{ bottomText }}</span>
          </div>
        </q-field>
      </div>
    </div>

    <div class="row justify-end">
      <q-btn type="submit" color="primary" @click="handleSave">{{ $t('save') }}</q-btn>
    </div>
  </q-tab-pane>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import InviteMember from 'components/Team/Members/InviteMember.vue'
  import { createErrorFromResponse } from 'src/utils/error'

  export default {
    inject: ['$validator'],

    computed: {
      ...mapGetters(['team']),

      memberCount () {
        return this.team.members.length
      },

      business () {
        return this.team.subscription
          ? this.team.subscription.stripe_plan.includes('business')
          : false
      },

      bottomText () {
        if (this.readOnlyUser.type === null) {
          return
        }

        return this.readOnlyUser.type === 'member'
          ? this.$t('invite_accepted_accountant')
          : this.$t('invite_open_accountant')
      },

      readOnlyUser () {
        const invites = l => l.filter(m => m.role_id === 3)
        const member = invites(this.team.members)
        const invite = invites(this.team.invites)

        if (member.length + invite.length > 1) {
          throw new Error('invalid read-only user count, this should never happen')
        }

        if (member.length === 0 && invite.length === 0) {
          return { email: '', type: null }
        }

        return member.length > 0
          ? { email: member[0].email, id: member[0].id, type: 'member' }
          : { email: invite[0].email, id: invite[0].id, type: 'invite' }
      }
    },

    methods: {
      ...mapActions(['removeTeamInvite', 'removeTeamMember', 'createTeamInvite']),

      handleSave () {
        let promise = Promise.resolve()
        if (this.readOnlyUser.type === 'invite') {
          promise = this.removeTeamInvite(this.readOnlyUser.id)
        }

        if (this.readOnlyUser.type === 'member') {
          promise = this.removeTeamMember({ team: this.team, userId: this.readOnlyUser.id })
        }

        promise
          .then(() => {
            return this.createTeamInvite({
              teamId: this.team.id,
              invite: {
                email: this.email,
                role_id: 3
              }
            })
          })
          .then(() => {
            this.$q.notify({ type: 'positive', message: this.$t('invite_created') })
          })
          .catch(createErrorFromResponse)
      }
    },

    data () {
      return {
        email: ''
      }
    },

    created () {
      this.email = this.readOnlyUser.email
    },

    components: {
      InviteMember
    }
  }
</script>
